import { gql } from '@apollo/client';

export const TRANSLATE_ARTICLE = gql`
  query Translation_translateArticle(
    $title: String!
    $content: String!
    $language: String
  ) {
    translation_translateArticle(
      title: $title
      content: $content
      language: $language
    ) {
      title
      content
    }
  }
`;
